export const initialState = {
    permissions: [],
    formattedPermissions: [],
    permissionGroups: [],
    permissionGroupTitle: null,
    permissionToCreate: {},
    selectedUserPermissions: [],
    selectedUserPermissionGroups: [],
    groupToEdit: '',
    permissionToEdit: '',
    permissionUnits: [],
    userPermissionUnits: [],
    permissionRooms: [],
    userPermissionRooms: [],
    userPermissionRepeaterRooms: [],
}